import styles from './Notifications.module.scss';
import { TemplateInfoMap, TemplateTypes, WidgetStatuses } from './constants';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import APP_ROUTES from '../../layout/Routes';
import { navigateToCaseDetails } from '../../utils/commonUtils';
import { hasNotCompletedAction } from './utils';
import { triggerNotificationAction } from './NotificationsActions';
import { RootState } from '../../store';
import NotificationBell from '../../assets/images/icons/NotificationBell';
import Typography from '@primitives/Typography';
import cx from 'classnames';
import { getReporteesWithAllocation } from '../sidebar/actions/escalationsAction';
import { setShowLogoutModal } from '@cp/src/reducers/commonSlice';

interface FcmNotificationProps {
  notification: any;
}

const FcmNotification = ({ notification }: FcmNotificationProps) => {
  const { notificationTemplate } = notification;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const widget = notificationTemplate?.widgets?.[0];
  const phoneNumber = useSelector((state: RootState) => state.common.userData?.phoneNumber);
  const agentReferenceId = useSelector((state: RootState) => state.common.userData?.referenceId);
  const countOfEscalationEnabled = useSelector(
    (state: RootState) => state?.common?.featureFlags?.countOfEscalationEnabled
  );
  const handleNotificationClick = () => {
    const { params } = notification;
    if (
      [
        TemplateTypes.CASE_ALLOCATED_NOTIFICATION_TEMPLATE,
        TemplateTypes.CASE_DE_ALLOCATED_NOTIFICATION_TEMPLATE
      ].includes(notificationTemplate?.templateName)
    ) {
      navigate(APP_ROUTES.CASES.path);
    } else if (TemplateTypes.COLLECTION_ESCALATION_RAISED === notificationTemplate?.templateName) {
      dispatch(getReporteesWithAllocation(agentReferenceId || '', countOfEscalationEnabled));
      dispatch(setShowLogoutModal(true));
    } else {
      navigateToCaseDetails(
        params?.customerReferenceId,
        notification.externalRefId,
        params?.caseReferenceId,
        params?.businessVertical,
        navigate,
        APP_ROUTES.CASE_DETAIL.path
      );
    }
    const actionCompleted = !hasNotCompletedAction(notification);
    if (actionCompleted) {
      return;
    }
    const payload = {
      id: notification.id,
      action: {
        widgetId: widget.widgetId,
        widgetStatus: WidgetStatuses.CLICKED,
        timestamp: Date.now(),
        actionBy: phoneNumber
      }
    };
    dispatch(triggerNotificationAction(payload));
  };

  return (
    <div className={styles.toastContainer}>
      <div className={styles.toastHeader}>
        <NotificationBell />
        <Typography variant="h4">1 new notification</Typography>
      </div>
      <div className={cx(styles['notificationList'], styles.notifContainer)}>
        <div
          key={notification.id}
          className={cx(styles['notificationList__item'], [
            styles['notificationList__item__notif']
          ])}
          onClick={() => handleNotificationClick()}
        >
          <div className={styles['notificationList__item__icon']}>
            {TemplateInfoMap[notificationTemplate.templateName]?.icon}
          </div>
          <div>
            <div dangerouslySetInnerHTML={{ __html: notification.body.notificationText }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FcmNotification;
